import { useTranslation } from 'react-i18next'

import { EntityProfileHeaderInfoItemBase } from '../../../../../Entity'
import Text from '../../../../../Text'
import {
  LISTING_PROFILE_INFO_ITEM_TITLE_KEY,
  QA_NAME_LISTING_PROFILE_INFO_RENT,
} from '../RentalPortalListingProfileHeaderInfoItems.constants'

function ListingProfileRentItem({
  className,
  contentWrapperClassName,
  titleClassName,
  value,
}) {
  const { t } = useTranslation()

  return (
    <EntityProfileHeaderInfoItemBase
      actions={null}
      canEdit={false}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      title={LISTING_PROFILE_INFO_ITEM_TITLE_KEY.rent}
      titleClassName={titleClassName}
      tooltip={value}
    >
      <Text
        disabled={!value}
        isSecondary={!value}
        qaName={QA_NAME_LISTING_PROFILE_INFO_RENT}
      >
        {value ?? t('Select.NoDataKey')}
      </Text>
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ListingProfileRentItem
